import { CalendarPlus } from "lucide-react";
import { ADDRESS } from "@/lib/api";

const esc = (s) => String(s).replace(/[\\,;]/g, (m) => `\\${m}`).replace(/\n/g, "\\n");

const icsFile = (b) =>
  [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//P7 BARBING SALON//Reservas//ES", "CALSCALE:GREGORIAN", "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:${b.id}@p7barbingsalon`,
    `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "")}`,
    `DTSTART:${b.cal_start}`, `DTEND:${b.cal_end}`,
    `SUMMARY:${esc(`${b.service_name} · P7 BARBING SALON`)}`,
    `DESCRIPTION:${esc(`Código de reserva: ${b.code}`)}`,
    `LOCATION:${esc(ADDRESS)}`,
    "BEGIN:VALARM", "TRIGGER:-PT2H", "ACTION:DISPLAY", "DESCRIPTION:Cita en P7 BARBING SALON", "END:VALARM",
    "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");

const download = (b) => {
  const url = URL.createObjectURL(new Blob([icsFile(b)], { type: "text/calendar;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `cita-p7-${b.code}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

const googleUrl = (b) =>
  `https://calendar.google.com/calendar/render?${new URLSearchParams({
    action: "TEMPLATE",
    text: `${b.service_name} · P7 BARBING SALON`,
    dates: `${b.cal_start}/${b.cal_end}`,
    details: `Código de reserva: ${b.code}`,
    location: ADDRESS,
  })}`;

export const AddToCalendar = ({ b, compact = false }) => {
  if (!b?.cal_start) return null;
  const cls = compact
    ? "text-xs underline text-zinc-600 hover:text-[#111111]"
    : "h-12 px-6 inline-flex items-center gap-2 border border-[#111111] text-xs tracking-[0.2em] uppercase hover:bg-[#111111] hover:text-white transition-colors";
  return (
    <div className={`flex flex-wrap gap-3 ${compact ? "" : "mt-6"}`} data-testid={`add-to-calendar-${b.code}`}>
      <button type="button" onClick={() => download(b)} className={cls} data-testid={`calendar-ics-${b.code}`}>
        {!compact && <CalendarPlus className="w-4 h-4" />} {compact ? "Calendario (iPhone/Android)" : "Añadir a calendario"}
      </button>
      <a href={googleUrl(b)} target="_blank" rel="noopener noreferrer" className={cls} data-testid={`calendar-google-${b.code}`}>
        Google Calendar
      </a>
    </div>
  );
};
